import React from 'react';
import Station from '../../models/Station';
import TooltipTotalizer from '../TooltipTotalizer';

interface PricingTitleProps {
    station: Station | undefined;
}

const PricingTitle: React.FC<PricingTitleProps> = ({ station }) => {
    // Calculate kW from cluster's maxVoltage * maxAmps / 1000
    let kwDisplay = '7.68';
    if (station?.cluster?.maxVoltage && station?.cluster?.maxAmps) {
        const calculatedKw =
            (station.cluster.maxVoltage * station.cluster.maxAmps) / 1000;
        kwDisplay = calculatedKw.toFixed(2);
    }

    return (
        <div className="pricing__current-price">
            <p className="pricing__price-title">
                Station {station?.qrCode}
                <TooltipTotalizer
                    kwh={((station?.totalizer || 0) / 1000).toFixed(4)}
                />
            </p>
            <p className="pricing__details">
                {kwDisplay} kW | Load share {station?.clusterCount}:1
            </p>
        </div>
    );
};

export default PricingTitle;
